import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const baseURL = "http://192.168.1.240:10005";
const baseURL = "";

export default class UserAdministratorService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getRolesSearch(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/roles-search`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Chi tiết
  public getDetailByIds(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/auth/users/roles/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Thêm mới
  public getCreateAuthUser(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/roles`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Chỉnh sửa
  public getEditAuthUser(id: any, queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseURL + `/api/auth/users/roles/${id}`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Xóa
  public getDelete(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(baseURL + `/api/auth/users/roles/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // get User
  public getAccountUser(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/search`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
